import BaseAPI from './base.api';

export default class DtcAPI extends BaseAPI {
  getAllData = async (payload: { startDate: string; endDate: string }) => {
    const response = await this.API.post('dtc', payload);
    return response.data;
  };

  getAllGroupedData = async (payload: {
    startDate: string;
    endDate: string;
  }) => {
    const response = await this.API.post('dtc/grouped', payload);
    return response.data;
  };

  exportToExcel = async (payload: {
    startDate: string;
    endDate: string;
    format: string;
  }) => {
    const response = await this.API.post('dtc/reports', payload, {
      responseType: 'blob', // Important for handling file downloads
    });

    return response.data;
  };
}
